module.exports = __webpack_public_path__ + "img/timmy-01.21ec389b.png";